export default __webpack_public_path__ + "static/media/zerodha-1.65f2c077.svg";